import React, { ReactNode } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const AdditionalInfoContext = React.createContext<{
    value: null;
    set: (v: any) => void;
} | undefined>(undefined);

export const AdditionalInfoProvider = ({ children }: { children: ReactNode }) => {
    const [v, setV] = React.useState(null);

    return (
        <AdditionalInfoContext.Provider value={{ value: v, set(v) {} }}>
            {children}
        </AdditionalInfoContext.Provider>
    );
};

export const useAdditionalInfo = () => {
    const ctx = React.useContext(AdditionalInfoContext);
    if (!ctx) {
        throw new Error('eAdditionalInfo must be used inside AdditionalInfoProvider');
    }
    return ctx;
};
